

module.exports=[

    [
        "#000000",
        "#00340C",
        "#045514",
        "#045D14",
        "#048620",
        "#049220",
        "#08BA2C",
        "#08C72C",
        "#048A20",
        "#08A224",
        "#08C32C",
        "#08CB30",
        "#0BE734",
        "#0BEF38",
        "#24FF51",
        "#34FF5D"
        ]
        
     ,[
        "#000000",
        "#551400",
        "#792400",
        "#862C00",
        "#AE4900",
        "#BE5500",
        "#E37101",
        "#EF7900",
        "#B24D00",
        "#CB5D00",
        "#EB7900",
        "#F37D00",
        "#FF9E04",
        "#FFAA10",
        "#FFDB30",
        "#FFE334"
        ]
        
       , 
    [
        "#000000",
        "#343434",
        "#494949",
        "#555555",
        "#797979",
        "#828282",
        "#A6A6A6",
        "#B2B2B2",
        "#2B2B2B",
        "#8E8E8E",
        "#AEAEAE",
        "#B6B6B6",
        "#D3D3D3",
        "#DBDBDB",
        "#F7F7F7",
        "#FFFFFF"
        ]
]

